import React, { useState, useEffect } from 'react';
import './ErrorNotification.css';

export const ErrorNotification = ({ message, duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible || !message) return null;

  return (
    <div className="error-notification">
      <div className="error-notification-content">
        <span className="error-notification-message">{message}</span>
        <button 
          className="error-notification-close"
          onClick={handleClose}
          aria-label="Закрыть"
        >
          ×
        </button>
      </div>
    </div>
  );
};